/**
 * CleverTap Events Tracking
 * @author Arvin Laya <arvin@gorated.ph>
 * @since Version {x.x.x}
 *
 * Reference: https://developer.clevertap.com/docs/web-overview
 */
import { __decorate } from "tslib";
// Disable eslint here since most code will cause false positives
// False positives happen when eslint tries to evaluate third party libraries code
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator';
import CleverTapAppDetails from '@/plugins/graphql/queries/v3/clevertap-app-details.gql';
let CleverTapEventsMixin = class CleverTapEventsMixin extends Vue {
    constructor() {
        super(...arguments);
        this.clevertapAppDetails = {
            app_bundle_key: '',
            app_name: '',
            app_plan: '',
            app_plan_payment_type: '',
        };
    }
    get path() {
        return window.location.href;
    }
    get clevertapAppUUID() {
        return this.$route.params.appUUID;
    }
    // Extract clevertap object from global scope
    get clevertap() {
        return window.clevertap;
    }
    // Login page events
    viewLoginPage() {
        this.clevertap?.event?.push('View Login Page', {
            path: this.path,
        });
    }
    onLogin({ firstName = '', lastName = '', email = '', contactNumber = '' }) {
        this.clevertap.onUserLogin.push({
            'Site': {
                'Name': `${firstName} ${lastName}`,
                'Identity': this.$route.params.clevertapId,
                'Email': email,
                'Phone': `+63${contactNumber}`,
                'MSG-email': true,
            }
        });
        this.clevertap?.event?.push('Logged In');
    }
    // Apps page events
    viewAppsPage() {
        this.clevertap?.event?.push('View Apps Page', {
            path: this.path
        });
    }
    onAccountSecurityUpdate() {
        this.clevertap?.event?.push('Account Security Update');
    }
    // DIY events
    viewDIYPage(step = '') {
        this.clevertap?.event?.push('View DIY Page', {
            step,
            path: this.path
        });
    }
    onDIYSelectBundle(bundle = '') {
        this.clevertap?.event?.push('DIY Selected Bundle', {
            bundle,
            path: this.path
        });
    }
    onDIYChoosePlan(plan = '', paymentType = '', duration) {
        this.clevertap?.event?.push('DIY Selected Plan', {
            plan,
            billing_type: duration === 1 ? 'Monthly' : 'Annually',
            payment_type: paymentType,
            path: this.path
        });
    }
    onDIYConnectFacebookPage(pageName = '') {
        this.clevertap?.event?.push('DIY Connected Facebook Page', {
            page_name: pageName,
            path: this.path
        });
    }
    onDIYSubmitAppSettings(hasAppName, hasGreeting, hasWelcomeMessageContent, hasWelcomeButtonTitle, hasReferralCode, hasEmailNotifRecipients, hasSupportEmailList, hasSupportContactNumber) {
        this.clevertap?.event?.push('DIY Setup In-App Store', {
            provided_app_name: hasAppName,
            provided_greeting: hasGreeting,
            provided_welcome_message: hasWelcomeMessageContent,
            provided_welcome_button: hasWelcomeButtonTitle,
            provided_referral_code: hasReferralCode,
            provided_email_recipient: hasEmailNotifRecipients,
            provided_support_email: hasSupportEmailList,
            provided_support_number: hasSupportContactNumber,
            path: this.path
        });
    }
    // Merchant Dashboard Global Events
    onAppLaunch() {
        this.clevertap?.event?.push('In-App Store Launched', {
            path: this.path,
            ...this.clevertapAppDetails
        });
    }
    onAppDisconnect(channel) {
        this.clevertap?.event?.push('In-App Store Disconnected', {
            channel,
            path: this.path,
            ...this.clevertapAppDetails
        });
    }
    // Merchant Overview
    viewOverviewPage() {
        this.clevertap?.event?.push('View Overview Page', {
            path: this.path,
            ...this.clevertapAppDetails
        });
    }
    onTodoListButtonClick(taskName = '') {
        this.clevertap?.event?.push('Todo List Button Click', {
            task_name: taskName,
            path: this.path,
            ...this.clevertapAppDetails
        });
    }
    // Merchant Products Category
    viewProductCategoriesPage() {
        this.clevertap?.event?.push('View Product Categories', {
            path: this.path,
            ...this.clevertapAppDetails
        });
    }
    productCategoryAction(action) {
        this.clevertap?.event?.push('Product Category Action', {
            action,
            path: this.path,
            ...this.clevertapAppDetails
        });
    }
    // Merchant Products
    viewProductsPage() {
        this.clevertap?.event?.push('View Products Page', {
            path: this.path,
            ...this.clevertapAppDetails
        });
    }
    productAction(action) {
        this.clevertap?.event?.push('Product Action', {
            action,
            path: this.path,
            ...this.clevertapAppDetails
        });
    }
    generateProductDescriptionAction(appName, action, productName) {
        this.clevertap?.event?.push('Gen AI', {
            generateType: 'Product Description',
            appName,
            productName,
            action,
            path: this.path,
            ...this.clevertapAppDetails
        });
    }
    genAIAction(generateType, appName, action) {
        this.clevertap?.event?.push('Gen AI', {
            generateType,
            appName,
            action,
            path: this.path,
            ...this.clevertapAppDetails
        });
    }
    // Merchant Add-Ons
    viewAddOnsPage() {
        this.clevertap?.event?.push('View Add Ons Page', {
            path: this.path,
            ...this.clevertapAppDetails
        });
    }
    addOnAction(action) {
        this.clevertap?.event?.push('Add-On Action', {
            action,
            path: this.path,
            ...this.clevertapAppDetails
        });
    }
    // Merchant Cart Settings
    viewCartSettingsPage() {
        this.clevertap?.event?.push('View Checkout Settings Page', {
            path: this.path,
            ...this.clevertapAppDetails
        });
    }
    cartSettingAction(action) {
        this.clevertap?.event?.push('Cart Setting Action', {
            action,
            path: this.path,
            ...this.clevertapAppDetails
        });
    }
    // Merchant Delivery Areas
    viewDeliveryAreasPage() {
        this.clevertap?.event?.push('View Delivery Areas Page', {
            path: this.path,
            ...this.clevertapAppDetails
        });
    }
    deliveryAreaAction(action) {
        this.clevertap?.event?.push('Delivery Area Action', {
            action,
            path: this.path,
            ...this.clevertapAppDetails
        });
    }
    // Merchant Orders Tracker
    viewOrdersPage() {
        this.clevertap?.event?.push('View Orders Page', {
            path: this.path,
            ...this.clevertapAppDetails
        });
    }
    orderAction(action) {
        this.clevertap?.event?.push('Order Action', {
            action,
            path: this.path,
            ...this.clevertapAppDetails
        });
    }
    // Merchant Orders History
    viewOrdersHistory() {
        this.clevertap?.event?.push('View Orders History Page', {
            path: this.path,
            ...this.clevertapAppDetails
        });
    }
    // Merchant Shipping Manager
    viewShippingManagerPage() {
        this.clevertap?.event?.push('View Shipping Manager Page', {
            path: this.path,
            ...this.clevertapAppDetails
        });
    }
    shippingManagerAction(action, shippingName = '') {
        this.clevertap?.event?.push('Shipping Manager Action', {
            shipping_name: shippingName,
            action,
            path: this.path,
            ...this.clevertapAppDetails
        });
    }
    // Merchant Payment Manager
    viewPaymentManagerPage() {
        this.clevertap?.event?.push('View Payment Manager Page', {
            path: this.path,
            ...this.clevertapAppDetails
        });
    }
    paymentManagerAction(action, paymentName = '') {
        this.clevertap?.event?.push('Payment Manager Action', {
            payment_name: paymentName,
            action,
            path: this.path,
            ...this.clevertapAppDetails
        });
    }
    // Merchant Marketing Tools
    viewCustomerSegmentPage() {
        this.clevertap?.event?.push('View Customer Segment Page', {
            path: this.path,
            ...this.clevertapAppDetails
        });
    }
    customerSegmentAction(action) {
        this.clevertap?.event?.push('Customer Segment Action', {
            action,
            path: this.path,
            ...this.clevertapAppDetails
        });
    }
    viewBroadcastPage() {
        this.clevertap?.event?.push('View Broadcast Page', {
            path: this.path,
            ...this.clevertapAppDetails
        });
    }
    broadcastAction(action) {
        this.clevertap?.event?.push('Broadcast Segment Action', {
            action,
            path: this.path,
            ...this.clevertapAppDetails
        });
    }
    viewVouchersPage() {
        this.clevertap?.event?.push('View Vouchers Page', {
            path: this.path,
            ...this.clevertapAppDetails
        });
    }
    voucherAction(action) {
        this.clevertap?.event?.push('Voucher Action', {
            action,
            path: this.path,
            ...this.clevertapAppDetails
        });
    }
    viewCartPromosPage() {
        this.clevertap?.event?.push('View Cart Promos Page', {
            path: this.path,
            ...this.clevertapAppDetails
        });
    }
    cartPromoAction(action) {
        this.clevertap?.event?.push('Cart Promo Action', {
            action,
            path: this.path,
            ...this.clevertapAppDetails
        });
    }
    viewNotificationManagerPage() {
        this.clevertap?.event?.push('View Notification Manager Page', {
            path: this.path,
            ...this.clevertapAppDetails
        });
    }
    notificationManagerAction(action, notificationType) {
        this.clevertap?.event?.push('Notification Manager Action', {
            action,
            notification_type: notificationType,
            path: this.path,
            ...this.clevertapAppDetails
        });
    }
    // Merchant Referrals
    viewReferralsPage() {
        this.clevertap?.event?.push('View Referrals Page', {
            path: this.path,
            ...this.clevertapAppDetails
        });
    }
    referralAction(action) {
        this.clevertap?.event?.push('Referral Action', {
            action,
            path: this.path,
            ...this.clevertapAppDetails
        });
    }
    // Merchant Terms And Agreement
    viewTermsAndAgreementPage() {
        this.clevertap?.event?.push('View Terms And Agreeement Page', {
            path: this.path,
            ...this.clevertapAppDetails
        });
    }
    // Merchant Billing Manager
    viewBillingManagerPage() {
        this.clevertap?.event?.push('View Billing Manager Page', {
            path: this.path,
            ...this.clevertapAppDetails
        });
    }
    viewSubscriptionPlansPage() {
        this.clevertap?.event?.push('View Subscription Plans Page', {
            path: this.path,
            ...this.clevertapAppDetails
        });
    }
    planSubscribe(plan = '', duration = 1) {
        this.clevertap?.event?.push('Plan Subscribe', {
            plan,
            billing_type: duration === 1 ? 'MONTHLY' : 'ANNUALLY',
            path: this.path
        });
    }
    viewAutomationPage() {
        this.clevertap?.event?.push('View Automation Page', {
            path: this.path,
            ...this.clevertapAppDetails
        });
    }
    automationAction(action) {
        this.clevertap?.event?.push('Automation Action', {
            action,
            path: this.path,
            ...this.clevertapAppDetails
        });
    }
    viewAffiliateSettingsPage() {
        this.clevertap?.event?.push('View Affiliate Settings Page', {
            path: this.path,
            ...this.clevertapAppDetails
        });
    }
    shopifySettingsAction(action) {
        this.clevertap?.event?.push('Shopify Settings Action', {
            action,
            path: this.path,
            ...this.clevertapAppDetails
        });
    }
    fbCatalogAction(action) {
        this.clevertap?.event?.push('Facebook Catalog Action', {
            action,
            path: this.path,
            ...this.clevertapAppDetails
        });
    }
};
CleverTapEventsMixin = __decorate([
    Component({
        apollo: {
            clevertapAppDetails: {
                query: CleverTapAppDetails,
                variables() {
                    return {
                        appUuid: this.clevertapAppUUID,
                    };
                },
                skip() {
                    return !this.clevertapAppUUID;
                },
                update(data) {
                    data = data.fetchAppByUuid;
                    return {
                        app_bundle_key: data.bundleKey,
                        app_name: data.name,
                        app_plan: data.plan,
                        plan_payment_type: data.planPaymentType,
                    };
                },
            },
        },
    })
], CleverTapEventsMixin);
export default CleverTapEventsMixin;
